export const getNeuSurfaceStyles = (theme, variant = "panel") => {
  const elevation = theme.custom.elevation?.[variant];
  const surface = theme.custom.surfaces?.[variant] ?? theme.custom.surfaces?.panel;

  return {
    color: theme.palette.text.primary,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: surface?.light ?? theme.palette.background.paper,
    backgroundImage: "none",
    border: "none",
    boxShadow: elevation?.light ?? "none",

    ...theme.applyStyles("dark", {
      backgroundColor: surface?.dark ?? theme.palette.background.paper,
      boxShadow: elevation?.dark ?? "none",
    }),
  };
};

export const getNeuVariantStyles = (theme, variant) => {
  const styles = {
    default: {
      color: theme.palette.text.primary,
      transition: "none",
    },

    lime: {
      background: theme.custom.gradients.accent,
      color: theme.palette.primary.contrastText,
      "&:hover": {
        boxShadow: theme.custom.effects.accentRaised,
        transform: "translateY(-1px)",
      },
      "&:active": {
        transform: "scale(0.98)",
        boxShadow: theme.custom.effects.accentInset,
      },
    },

    purple: {
      background: theme.custom.gradients.brand,
      color: theme.palette.secondary.contrastText,
      "&:hover": {
        transform: "translateY(-1px)",
      },
    },

    gradientBorderLime: {
      background: theme.custom.gradients.accent,
      color: theme.palette.text.primary,
    },

    gradientBorderPurple: {
      background: theme.custom.gradients.brand,
      color: theme.palette.text.primary,
    },
  };

  return styles[variant] || styles.default;
};


export const getNeuMenuPaperStyles = (theme) => ({
  ...getNeuSurfaceStyles(theme, "control"),
  marginTop: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  overflow: "hidden",

  "& .MuiList-root": {
    padding: 0,
  },

  "& .MuiMenuItem-root": {
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },

  "& .MuiMenuItem-root:last-of-type": {
    borderBottom: "none",
  },
});

export const getNeuTooltipStyles = (theme) => ({
  tooltip: {
    p: 1.5,
    borderRadius: 3,
    backgroundColor: `${theme.palette.secondary.contrastText}80`,
    color: theme.palette.text.primary,
    boxShadow: theme.custom.shadows?.raised,
    backdropFilter: "blur(50px)",
    border: `2px solid ${theme.palette.secondary.main}`,
    ...theme.applyStyles("dark", {
      border: `2px solid ${theme.palette.primary.main}`,
      backgroundColor: `${theme.palette.primary.main}10`,
    }),
  },

  arrow: {
    color: theme.palette.secondary.main,
    ...theme.applyStyles("dark", {
      color: theme.palette.primary.main,
    }),
  },
});

export const getAccentVariantStyles = (theme, accentVariant) => {
  const styles = {
    default: {
      color: theme.palette.text.primary,
      transition: "none",
    },

    limeTint: {
      background: theme.custom.effects.limeTint,
      color: theme.palette.primary.contrastText,
      border: theme.custom.borders.lime,
      ...theme.applyStyles("dark", {
        backgroundColor: theme.custom.effects.limeTint,
        color: theme.palette.secondary.contrastText,
      }),
    },

    purpleTint: {
      background: theme.custom.effects.purpleTint,
      border: theme.custom.borders.purple,
      ...theme.applyStyles("dark", {
        backgroundColor: theme.custom.effects.purpleTint,
        color: theme.palette.secondary.contrastText,
      }),
    },

    gradientLime: {
      background: theme.custom.gradients.accent,
      color: theme.palette.primary.contrastText,
    },

    gradientPurple: {
      background: theme.custom.gradients.brand,
      color: theme.palette.secondary.contrastText,
    },
    gradientTeal: {
      background: theme.custom.gradients.teal,
      color: theme.palette.primary.contrastText,
    },
  };

  return styles[accentVariant] || styles.default;
};

export function getAccentIconBackground(theme, accentVariant) {
  switch (accentVariant) {
    case "gradientLime":
      return theme.custom.gradients.accentReverse;

    case "gradientPurple":
      return theme.custom.gradients.brandReverse;

    case "gradientTeal":
      return theme.custom.gradients.tealReverse;

    case "lime":
      return theme.palette.primary.main;

    case "purple":
      return theme.palette.secondary.main;

    default:
      return theme.custom.gradients.brandReverse;
  }
}

export function getAccentIconColor(theme, accentVariant) {
  switch (accentVariant) {
    case "gradientLime":
    case "lime":
      return theme.palette.secondary.main;

    case "gradientPurple":
    case "purple":
      return theme.palette.primary.main;
    case "gradientTeal":
      return theme.palette.text.primary;
    default:
      return theme.palette.primary.main;
  }
}

